import { render, staticRenderFns } from "./SuggestionBox.vue?vue&type=template&id=b0d03716&"
import script from "./SuggestionBox.vue?vue&type=script&lang=js&"
export * from "./SuggestionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports